import type { CustomAppConfigs } from "typings";

import minhasConsultasCustomConfigs from "./minhas-consultas";

export const customAppConfigs: CustomAppConfigs[] = [
  minhasConsultasCustomConfigs,
];
